module.exports = __webpack_public_path__ + "img/boat_parked.1eb24a80.svg";